import React, { useState, useEffect } from 'react';
import { Registro } from '../components/Register';

export const Registrop = () => {
 

  return (<>
    <Registro/>
  </>)
}